class Form {
  theme = null;

  constructor(theme) {
    this.theme = theme;
    Form.instance = this;
  }

  static init(theme) {
    Form.instance = null;
    return new Form(theme);
  }

  getRowStyle() {
    return {
      marginLeft: "20px",
      marginTop: "20px",
      display: "flex",
      alignItems: "center",
      gap: 2,
    };
  }

  getLabelStyle() {
    return {
      width: "150px",
      color: this.theme.palette.primary.greyPrimary,
      fontSize: this.theme.typography.customFontSize[2],
      fontWeight: this.theme.typography.customFontWeight[0],
    };
  }

  getTextfieldStyle = (isValid) => ({
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: this.theme.shape.customBorderRadius[1],
      height: "31px",
      backgroundColor: this.theme.palette.primary.white,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.borderGreyPrimary
          : this.theme.palette.primary.redPrimary,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.mainHover
          : this.theme.palette.primary.redPrimary,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.main
          : this.theme.palette.primary.redPrimary,
      },
    },
  });
}

Form.prototype.getTableStyle = function () {
  return {
    marginTop: "10px",
    padding: "10px",
    maxHeight: '400px',
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
  };
}

Form.prototype.getMaskStyle = function () {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 10,
    backgroundColor: this.theme.palette.primary.greyPrimary,
    opacity: 0.2,
    borderRadius: 8,
  };
}

Form.prototype.getInnerViewStyle = function (zIndex) {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    width: "100%",
    height: "auto",
    backgroundColor: this.theme.palette.primary.white,
    boxShadow: this.theme.shadows[5],
    borderRadius: this.theme.shape.customBorderRadius[2],
    zIndex: zIndex.modal + 2,
  };
}

Form.prototype.getInnerContainerStyle = function () {
  return {
    padding: "20px",
    width: "100%",
  }
}

Form.prototype.getAddItemTopContainerStyle = function () {
  return {
    display: "grid",
    gridTemplateColumns: "200px 300px 150px 150px",
    alignItems: "center",
  }
}

Form.prototype.getButtonContainerStyle = function () {
  return {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px',
    marginRight: '20px',
  }
}

Form.prototype.getAddButtonStyle = function () {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    border: `1px solid ${this.theme.palette.primary.main}`,
    borderRadius: '4px',
    padding: '4px 12px',
    minWidth: '120px',
    color: this.theme.palette.primary.main,
  }
}

Form.prototype.makeMacAddressItems = function (mac, count) {
  const base = parseInt(mac.replace(/[^0-9A-Fa-f]/g, ""), 16);

  const macs = [];
  for (let i = 0; i < count; i++) {
    const next = base + i;
    const hex = next.toString(16).padStart(12, "0").toUpperCase();
    const formatted = hex.match(/.{1,2}/g).join("-");
    macs.push(formatted);
  }

  return macs;
}

Form.prototype.validateMacAddress = function (macAddress) {
  const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
  return macRegex.test(macAddress);
}

Form.prototype.validateCount = function (count) {
  const countRegex = /^\d+$/;
  return countRegex.test(count);
}

Form.prototype.getNumberStyle = function (deleteAction = true) {
  return {
    minWidth: '24px',
    height: '20px',
    fontSize: '12px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: deleteAction ? this.theme.palette.primary.main : this.theme.palette.primary.white,
    color: deleteAction ? this.theme.palette.primary.white : this.theme.palette.primary.main,
    borderRadius: '15px',
    padding: '0 15px',
    marginLeft: '4px',
  };
}

export default Form;